import React from "react";
import ContactForm from "../components/common/ContactForm";

function Contact() {
  return (
    <div>
      <ContactForm />
    </div>
  );
}

export default Contact;
